import {StsApiError} from './sts-api-error';

export class StsErrorResponse {
  // errors: StsApiError[] = [];
  // errorDate: string;
  // referenceNumber: string;
  success: boolean;
  message: string;
  status: string;
  stsCode: string;
  error: any;
}
